export class HttpError extends Error {
  constructor(statusCode, body, message = "HTTP Error") {
    super(message);
    this.statusCode = statusCode;
    this.body = body;
  }
}
